import { SweepCanvasRfNode } from '../canvas-types/nodeTypesData';
import { CanvasElementType } from '../canvas-types';

/**
 * Sorts nodes to enforce a specific order:
 * 1. SECTION nodes first
 * 2. GROUP nodes second
 * 3. All other nodes after
 *
 * This ensures proper rendering order in the canvas. Children nodes should be rendered after their parents.
 */
export const sortNodes = (nodes: SweepCanvasRfNode[]): SweepCanvasRfNode[] => {
  return [...nodes].sort((a, b) => {
    if (a.type === CanvasElementType.SECTION && b.type !== CanvasElementType.SECTION) {
      return -1;
    }
    if (a.type !== CanvasElementType.SECTION && b.type === CanvasElementType.SECTION) {
      return 1;
    }

    if (a.type === CanvasElementType.GROUP && b.type !== CanvasElementType.GROUP) {
      return -1;
    }
    if (a.type !== CanvasElementType.GROUP && b.type === CanvasElementType.GROUP) {
      return 1;
    }

    return 0;
  });
};
